var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalsecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3575_4739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84919 0C6.93481 0 7.01188 0 7.09751 0C7.14032 0.0611688 7.20882 0.0349536 7.2602 0.0524304C9.29812 0.629164 11.3275 1.2059 13.3654 1.78263C13.6737 1.87002 13.7935 2.02731 13.8363 2.35937C13.9648 3.56526 14.0247 4.7799 13.999 5.99454C13.9733 7.11305 13.8706 8.23157 13.6223 9.32387C13.374 10.4249 12.9801 11.456 12.2951 12.3561C10.9935 14.0688 9.34093 15.2572 7.3287 15.9388C7.11463 16.0087 6.90913 16.0262 6.70362 15.9388C6.54949 15.8777 6.3868 15.834 6.22411 15.7728C4.7342 15.1961 3.4498 14.3135 2.36234 13.1338C1.61738 12.3299 1.02656 11.4473 0.68405 10.3987C0.255915 9.07045 0.0760988 7.70726 0.0161599 6.31786C-0.0352162 4.99836 0.0247226 3.67886 0.170288 2.35937C0.204539 2.01857 0.332979 1.87002 0.649799 1.78263C2.49078 1.25833 4.34032 0.742764 6.1813 0.209721C6.40393 0.148553 6.63512 0.113599 6.84919 0ZM6.41249 10.4773C6.55806 10.4773 6.67793 10.4074 6.78069 10.3026C8.20209 8.85199 9.61494 7.41016 11.0363 5.95958C11.2675 5.72365 11.2675 5.42654 11.0363 5.18187C10.8993 5.03331 10.7538 4.8935 10.6168 4.75369C10.3 4.43037 10.0345 4.43037 9.70913 4.75369C8.64735 5.84599 7.57702 6.93828 6.50668 8.03932C6.42105 8.12671 6.37824 8.12671 6.30118 8.03932C5.76173 7.48007 5.22228 6.92955 4.68283 6.37903C4.42595 6.11688 4.13481 6.11688 3.87793 6.37903C3.71524 6.54506 3.55255 6.70235 3.38986 6.87712C3.18436 7.10431 3.17579 7.39268 3.38986 7.61988C4.27182 8.52867 5.15377 9.42873 6.04429 10.3288C6.13848 10.4336 6.26692 10.4861 6.41249 10.4773Z",
    fill: "#AAA4C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3575_4739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalsecurity);
export default __webpack_public_path__ + "static/media/legal&security.0bca3738965c736c747fec215eed3aff.svg";
export { ForwardRef as ReactComponent };